const STATUS_ABNORMAL = 0;
const STATUS_NOT_STARTED = 1;
const STATUS_SECTION_ONE = 2;
const STATUS_SECTION_ONE_OVER = 3;
const STATUS_SECTION_TWO = 4;
const STATUS_SECTION_TWO_OVER = 5;
const STATUS_SECTION_THREE = 6;
const STATUS_SECTION_THREE_OVER = 7;
const STATUS_SECTION_FOUR = 8;
const STATUS_OVERTIME = 9;
const STATUS_END = 10;
const STATUS_INTERRUPT = 11;
const STATUS_CALCEL = 12;
const STATUS_EXTENSION = 13;
const STATUS_CUT_IN_HALF = 14;
const STATUS_TO_BE_DETERMINED = 15;

export = {
  STAGE_MODE_LEAGUE: 1,
  STAGE_MODE_CUP: 2,

  // basketball
  STATUS_ABNORMAL,
  STATUS_NOT_STARTED,
  STATUS_SECTION_ONE,
  STATUS_SECTION_ONE_OVER,
  STATUS_SECTION_TWO,
  STATUS_SECTION_TWO_OVER,
  STATUS_SECTION_THREE,
  STATUS_SECTION_THREE_OVER,
  STATUS_SECTION_FOUR,
  STATUS_OVERTIME,
  STATUS_END,
  STATUS_INTERRUPT,
  STATUS_CALCEL,
  STATUS_EXTENSION,
  STATUS_CUT_IN_HALF,
  STATUS_TO_BE_DETERMINED,
  LIST_STATUS_PLAYING: [
    STATUS_SECTION_ONE,
    STATUS_SECTION_ONE_OVER,
    STATUS_SECTION_TWO,
    STATUS_SECTION_TWO_OVER,
    STATUS_SECTION_THREE,
    STATUS_SECTION_THREE_OVER,
    STATUS_SECTION_FOUR,
    STATUS_OVERTIME
  ],
  MATCH_STATUS_TEXT: {
    0: "Bất thường",
    1: "Chưa bắt đầu",
    2: "Hiệp 1",
    3: "Hết Hiệp 1",
    4: "Hiệp 2",
    5: "Hết Hiệp 2",
    6: "Hiệp 3",
    7: "Hết Hiệp 3",
    8: "Hiệp 4",
    9: "Hiệp phụ",
    10: "Kết thúc",
    11: "Gián đoạn",
    12: "Hủy bỏ",
    13: "Phần mở rộng",
    14: "Cắt một nửa",
    15: "Chưa xác định",
  },
};
